import React, { useMemo, useState } from 'react'
import CoOrdinatorListTable from '../admin/CoOrdinatorListTable'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
import AdminToolbar from '../admin/components/AdminToolbar';
import { useAdminCoOrdinatorList} from '../../assets/api/useAdminApi';
import { useDialog } from '../../shared/hook/useDialog';
import { Button, Grid2 } from '@mui/material';
import { Field, Formik, Form } from 'formik';
import * as yup from "yup";
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import { Constants } from '../../shared/constants';
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox';
import { LocationFilterFields } from '../../shared/components/LocationFilterFields';

const CoordinatorListTable = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [filters, setFilters] = useState({});
    const { open: openFilter, handleClickOpen: handleClickOpenFilter, handleClose: handleCloseFilter } = useDialog();
   
    const initialValues = {
        assigned_status: "",
        country_name: ""
    };
    
    const validationSchemaFilter = yup.object().shape({

    });

    const handleSubmitFilter = (values, { resetForm }) => {
        const filteredValues = Object.fromEntries(
            Object.entries(values).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
        );
        setFilters(filteredValues);
        handleCloseFilter();
        // resetForm()
    };
   
    const StatusOption = [
        {
            id: 1,
            label: "Assigned",
            value: "Assigned",
        },
        {
            id: 0,
            label: "Unassigned",
            value: "Unassigned",
        }
    ]
    
    const handleSearchChange = (value) => {
        setSearchQuery(value);
    };
    
    const { data: coOrdinatorlist, isLoading } = useAdminCoOrdinatorList(filters)
   
    const originalCoordinatorRows = useMemo(() => {
        return coOrdinatorlist?.data?.map((item, index) => ({
            sr_no: index + 1,
            ...item
        })) || [];
    }, [coOrdinatorlist])
   
    const filteredCoordinatorRows = useMemo(() => {
        if (!searchQuery.trim()) {
            return originalCoordinatorRows;
        }
        const lowercasedQuery = searchQuery.toLowerCase();
        return originalCoordinatorRows.filter(coordinator =>
            Object.values(coordinator).some(val =>
                val != null && val.toString().toLowerCase().includes(lowercasedQuery)
            )
        );
    }, [originalCoordinatorRows, searchQuery]);
   
    return (
        <>
            <NormalContainerWithHeader headerText={"Co-ordinator List"} RightContent={
                <AdminToolbar
                    onSearchChange={handleSearchChange}
                    onFilterClick={handleClickOpenFilter}
                    filterIcon={Constants.customImages.FilterDark}
                />
            }>
                <CoOrdinatorListTable coOrdinatorRows={filteredCoordinatorRows} isLoading={isLoading} />
            </NormalContainerWithHeader>
            <MainDialogBox open={openFilter} handleClose={handleCloseFilter} width={"40%"}>
                <Formik initialValues={filters} enableReinitialize={true} validationSchema={validationSchemaFilter} onSubmit={handleSubmitFilter}>
                    {() => (
                        <Form>
                            <Grid2 container spacing={"20px"}>
                                <Grid2 children size={12}>
                                    <Field
                                        name="assigned_status"
                                        component={IdAutoCompleteField}
                                        options={StatusOption}
                                        label="Status"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <LocationFilterFields
                                    countryField="country_name"
                                    stateField="state"
                                    cityField="city"
                                    isStoredId={false}
                                />
                                <Grid2 children textAlign={"end"} size={12}>
                                    <Button variant='contained' type='submit' fullWidth>Submit</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>
        </>
    )
}

export default CoordinatorListTable